import React from 'react';
import { Button, Dropdown, Header, Popup, Table } from 'semantic-ui-react';

import { clienteApi } from 'src/api';
import { Contexto } from 'src/contexto';
import { ComandoEliminarPagoCobroCalculado, PagoCobroCalculado } from '../tipos';
import ModalBase from './ModalBase';

const mapaFormasDePago = {
    efectivo: 'Efectivo',
    tarjeta: 'Tarjeta',
    cheque: 'Cheque',
    deposito: 'Depósito',
    transferencia: 'Transferencia',
};

function escribirFecha(fecha: string) {
    const [año, mes, dia] = fecha.split('-');
    return `${dia}-${mes}-${año}`;
}

function escribirMonto(monto: number) {
    const valorConPuntos = monto.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return '$' + valorConPuntos;
}

interface Props {
    idPlanDePago: string;
    pagos: Array<PagoCobroCalculado> | undefined;
    pagoSingular?: ComandoEliminarPagoCobroCalculado;
    alEditarPago(): void;
}

const enum Estado {
    Cerrado,
    EnEspera,
    Trabajando,
    Error,
}

interface State {
    estado: Estado;
    error: string;
}

class EliminarPagoCobroCalculado extends React.Component<Props, State> {
    public static readonly contextType = Contexto;
    public readonly context!: React.ContextType<typeof Contexto>;

    public state: State = {
        estado: Estado.Cerrado,
        error: '',
    };

    public render() {
        const { pagos, idPlanDePago } = this.props;

        const { estado, error } = this.state;

        switch (estado) {
            default:
                return (
                    <Dropdown.Item
                        text={<span style={{ color: 'red' }}>Eliminar pagos</span>}
                        onClick={this.abrirModal}
                    />
                );

            case Estado.EnEspera:
                return (
                    <ModalBase
                        cabecera={`Pagos`}
                        acciones={[
                            <Button
                                key='cancelar'
                                basic
                                content='Atras'
                                onClick={this.cerrarModal}
                            />,
                        ]}
                    >
                        {!pagos ? (
                            <Header as='h4'>No hay pagos registrados</Header>
                        ) : (
                            <Table>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell width={1}>Monto</Table.HeaderCell>
                                        <Table.HeaderCell width={1}>Interés</Table.HeaderCell>
                                        <Table.HeaderCell width={2}>Fecha</Table.HeaderCell>
                                        <Table.HeaderCell width={2}>Método</Table.HeaderCell>
                                        <Table.HeaderCell width={2}>Nº boleta</Table.HeaderCell>
                                        <Table.HeaderCell width={7}>Observaciones</Table.HeaderCell>
                                        <Table.HeaderCell width={7}>Eliminar</Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                    {pagos.map(pago => (
                                        <Table.Row key={pago.fechaDeRegistroDelPago}>
                                            <Table.Cell width={1}>
                                                {escribirMonto(pago.monto)}
                                            </Table.Cell>
                                            <Table.Cell width={1}>
                                                {escribirMonto(pago.interes)}
                                            </Table.Cell>
                                            <Table.Cell width={2}>
                                                {escribirFecha(pago.fecha)}
                                            </Table.Cell>
                                            <Table.Cell width={2}>
                                                {mapaFormasDePago[pago.idMetodoDePago]}
                                            </Table.Cell>
                                            <Table.Cell width={2}>{pago.numeroDeBoleta}</Table.Cell>
                                            <Table.Cell width={7}>{pago.observaciones}</Table.Cell>
                                            <Table.Cell textAlign='center' width={1}>
                                                <Popup
                                                    wide
                                                    trigger={
                                                        <Button
                                                            size='mini'
                                                            basic
                                                            color='red'
                                                            icon='trash'
                                                        />
                                                    }
                                                    on='click'
                                                    position='top right'
                                                >
                                                    <Header as='h4'>
                                                        Esta acción no se puede deshacer
                                                    </Header>

                                                    <p>
                                                        Esto eliminará definitivamente el registro
                                                        de este pago
                                                    </p>
                                                    <Button
                                                        color='red'
                                                        icon='trash'
                                                        size='small'
                                                        content='Eliminar pago'
                                                        onClick={() => {
                                                            this.eliminarPagoCobroCalculado({
                                                                idPlanDePago,
                                                                ...pago,
                                                            });
                                                        }}
                                                    />
                                                </Popup>
                                            </Table.Cell>
                                        </Table.Row>
                                    ))}
                                </Table.Body>
                            </Table>
                        )}
                    </ModalBase>
                );

            case Estado.Error:
                return (
                    <ModalBase
                        cabecera='Ocurrió un error'
                        iconoCabecera='exclamation triangle'
                        contenido={error}
                        acciones={<Button content='Entendido' onClick={this.cerrarModal} />}
                    />
                );

            case Estado.Trabajando:
                return <ModalBase cargando />;
        }
    }

    private readonly eliminarPagoCobroCalculado = (
        pagoAEliminar: ComandoEliminarPagoCobroCalculado,
    ) => {
        const { alEditarPago } = this.props;
        this.setState({ estado: Estado.Trabajando });
        clienteApi
            .ejecutar('eliminarPagoCobroCalculado', pagoAEliminar)
            .then(() => {
                alEditarPago();
                this.abrirModal();
            })
            .catch(error => {
                this.context.mostrarModalError(error);
                this.setState({
                    estado: Estado.Error,
                    error: 'Ocurrió un error mientras se comunicaba con el servidor.',
                });
            });
    };

    private readonly abrirModal = () => {
        this.setState({ estado: Estado.EnEspera });
    };

    private readonly cerrarModal = () => {
        this.setState(prevState => {
            if (prevState.estado !== Estado.Trabajando) {
                return { estado: Estado.Cerrado };
            }
            return { estado: prevState.estado };
        });
    };
}

export default EliminarPagoCobroCalculado;



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/componentes/FichaDeApoderado/Componentes/EliminarPagoCobroCalculado.tsx